import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TextButtonInternalAtomSharedComponent } from './text-button-internal.component';
import { IconSharedModule } from '../icon/entry';

@NgModule({
    declarations: [
        TextButtonInternalAtomSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule,
        RouterModule.forChild([])
    ],
    exports: [
        TextButtonInternalAtomSharedComponent
    ]
})

export class TextButtonInternalAtomSharedModule {}
